<!--
 * @Author: guoyu
 * @Date: 2021-05-26 17:05:56
 * @LastEditors: your name
 * @LastEditTime: 2021-05-28 14:17:08
 * @Description: 充值返利规则页
-->
<template>
  <div class="rebate-explian">
    <div class="top-bg"></div>
    <div class="rules">
      <p class="text-p">
        防疫期間宅在家裡，nicee就是你最好的陪伴，無限返現活動讓你輕鬆度這段特殊時期
      </p>
      <div class="title-block">活動時間</div>
      <p class="text-p p-center">05.29 00:00—06.30 24:00</p>
      <div class="title-block">活動說明</div>
      <p class="text-p">
        在活動時限內，在nicee<span class="stress-tip">任意完成一筆訂單</span
        >，即返還當前<span class="stress-tip">消費金額10%的nicee幣</span
        >作為防疫金獎勵到餘額賬戶。
      </p>
      <p class="text-p">不限品類，不限返現次數，不限現金金額上限。</p>
      <p class="text-p">
        返現數額為用戶實際付費金額，不包含優惠券、首單優惠。例：100元消費包含10元優惠券，則返現金額為(100-10)*10%=9
      </p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
.rebate-explian {
  background: url(./images/swave.png) no-repeat,
    linear-gradient(180deg, #ff7112 12.5%, #ffea7d 82.81%) no-repeat;
  background-position: center 155px, center top;
  background-size: 1920px 915px, 100% 533px;
}
.top-bg {
  width: 915px;
  height: 332px;
  margin: 0 auto;
  background: url(./images/ad.png) no-repeat, url(./images/money.png) no-repeat;
  background-size: 581px 132px, 290.18px 236.31px;
  background-position: left 67px, right 19px;
}
.rules {
  width: 915px;
  height: 441px;
  padding: 30px 123px;
  margin: 0 auto;
  background: linear-gradient(
    180deg,
    rgba(255, 100, 13, 0.62) 0%,
    #ff640d 100%
  );
  border-radius: 8px;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.4px;
  color: #ffffff;
}
.text-p {
  margin-bottom: 16px;
  line-height: 22px;
}
.p-center {
  text-align: center;
}
.title-block {
  width: 167px;
  height: 38px;
  padding: 6px 0 0;
  margin: 30px auto 16px;
  text-align: center;
  background: url(./images/title-bg.png) no-repeat;
  background-size: 100% 100%;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #ff6320;
}
.stress-tip {
  color: #ffe77a;
}
@media screen and (max-width: 599px) {
  .rebate-explian {
    background: url(./images/swave-mb.png) no-repeat,
      linear-gradient(180deg, #ff7112 12.5%, #ffea7d 82.81%) no-repeat;
    background-position: center 200px, center top;
    background-size: 100% 608px, 100% 415px;
  }
  .top-bg {
    width: auto;
    height: 244px;
    margin: 0 auto;
    background: url(./images/ad-mb.png) no-repeat,
      url(./images/money.png) no-repeat;
    background-size: 162px 89px, 157.18px 128px;
    background-position: 16px 89px, right 70px;
  }
  .rules {
    width: auto;
    height: 514px;
    padding: 25px 32px;
    margin: 0 16px 60px;
    text-align: justify;
    font-size: 16px;
    line-height: 22px;
  }
  .title-block {
    margin: 25px auto 14px;
  }
}
</style>
